import { SeverityNumber } from "@opentelemetry/api-logs";

import { CLIENT_SERVICE_NAME } from "@/src/instrumentation-resource";
import { emitLogRecord } from "@/src/utils/observability/emit-log-record";
import { ClientLogEvent } from "@/src/utils/observability/log-types";

const isDevelopment = process.env.NODE_ENV === "development";

/* eslint-disable logs/no-console-error, logs/no-console-warn, logs/no-console-info -- dev-only console mirror of emitted log records */
const getConsoleMirror = (
  severityNumber: SeverityNumber,
): typeof console.info => {
  switch (severityNumber) {
    case SeverityNumber.ERROR:
      return console.error;
    case SeverityNumber.WARN:
      return console.warn;
    default:
      return console.info;
  }
};
/* eslint-enable logs/no-console-error, logs/no-console-warn, logs/no-console-info */

const emit = (
  severityNumber: SeverityNumber,
  { category = "client", ...logEvent }: ClientLogEvent,
): void => {
  const { event, message, attributes, error } = logEvent;

  if (isDevelopment) {
    getConsoleMirror(severityNumber)(
      `[${SeverityNumber[severityNumber]}] ${event}`,
      {
        message,
        error,
        ...attributes,
      },
    );
  }

  emitLogRecord(CLIENT_SERVICE_NAME, severityNumber, { category, ...logEvent });
};

export const clientLogger = {
  info: (logEvent: ClientLogEvent): void => {
    emit(SeverityNumber.INFO, logEvent);
  },
  warn: (logEvent: ClientLogEvent): void => {
    emit(SeverityNumber.WARN, logEvent);
  },
  error: (logEvent: ClientLogEvent): void => {
    emit(SeverityNumber.ERROR, logEvent);
  },
};
